<template>
    <div v-if="storification" id="screen-instagram" ref="screen-instagram" class="preview-share-after-post background-img">
        <img crossorigin="anonymous" v-if="storification.image" class="share-img" :src="storification.image" alt="" @load="shareLoadImage" @error="shareLoadErrorImage">
        <p class="share-username" v-if="storification.image">@{{storification.username}}</p>
        <img :hidden="!storification.isCarousel" class="carousel-storification" src="../../assets/img/carousel.svg"/>
        <div v-if="link && link.url && link.isActive" :class="`draggable-${_uid} link-container-view style-link${0}`" data-name="Link" :data-init="link.initialDatas && JSON.stringify(link.initialDatas)"> 
            <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
            <p class="link-txt">{{link.text ? link.text.toUpperCase() : link.url.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
        </div>
    </div>
</template>

<script>
import ColorThief from 'color-thief-browser'
import interact from "interactjs";

const screenSize = {width: 360, height: 640}

export default {
    mounted() {

        console.log("MOUNT STORIFICATION", this._uid);
        if (!this.preview) {
            interact(`.draggable-${this._uid}`).draggable({
                modifiers: [
                    interact.modifiers.restrictRect({
                    restriction: this.$refs['screen-instagram'],
                    })
                ],
                listeners: {
                    move: this.moveDraggable,
                    end: this.updateStoreWithPosition
                }
            })
        }
        this.initDatas();

    },
    watch: {
        preview(newVal, oldVal) {
            if (newVal) {
                for (const [key, value] of Object.entries(newVal)) {
                    this.updatePreview(key, value);
                }
            }
        },
        link(newVal, oldVal) {
            if (!oldVal || !oldVal.url || !oldVal.isActive) {
                this.$nextTick(this.initDatas);
            }
        } 
    },
    data() {
        return {
      
        }
    },
    props: {
        storification: Object,
        link: Object,
        preview: {type: Object, default: null}
    },
    methods: {

        moveDraggable(event) {
            let x = parseFloat(event.target.getAttribute('data-x') || (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') || (event.target.offsetHeight/2));
            x += event.dx;
            y += event.dy;
            event.target.setAttribute("data-x", x);
            event.target.setAttribute("data-y", y);
            // event.target.style.transform = `translate(${x}px, ${y}px)`
            event.target.style.top = `${y - (event.target.offsetHeight/2)}px`;
            event.target.style.left = `${x - (event.target.offsetWidth/2)}px`;
        },

        updateStoreWithPosition(event) {
            let x = parseFloat(event.target.getAttribute('data-x') || (event.target.offsetWidth/2));
            let y = parseFloat(event.target.getAttribute('data-y') || (event.target.offsetHeight/2));
            let name = event.target.getAttribute('data-name')
            this.$store.commit(`updateStorification${name}`, {x, y})
        },

        updatePreview(name, values) {
            console.log(this.$el,this.$el.querySelector);
            let elmt = this.$el.querySelector(`[data-name="${name}"]`);
            if (elmt && values) {
                elmt.style.top = `${values.y - (elmt.offsetHeight/2)}px`;
                elmt.style.left = `${values.x - (elmt.offsetWidth/2)}px`;
            }
        },

        shareLoadErrorImage(e, origin=false) {
            console.log("@error=shareLoadErrorImage origin:", origin);
            let img = e.target;
            if (origin) {
                img.crossOrigin = undefined;
            }
            img.onerror = () => this.shareLoadErrorImage(e, true);
            if (!img.src.includes("timestamp")) {
                img.src += `?timestamp=${new Date().getTime()}`
            }
            img.style.backgroundColor = 'white';
        },

        shareLoadImage(e) {
            let colors
            try {
                let colorThief = new ColorThief();
                colors = colorThief.getPalette(e.target, 5).map(c => {
                return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
                })
            } catch(err) {
                console.log(err);
                colors = [`rgb(0,0,0)`, `rgb(0,0,0)`]
            }
            e.target.parentElement.style =  `background: linear-gradient(${colors[0]}, ${colors[1]})`;
            e.target.nextSibling.style = `top: ${e.target.parentElement.offsetHeight/2 + e.target.height/2 + 10}px`;
            e.target.parentElement.getElementsByClassName("carousel-storification")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.height/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.width/2 - 30}px;`
        },

        initDatas() {
            this.$el.querySelectorAll(`.draggable-${this._uid}`).forEach(element => {
                let x = (screenSize.width / 2);
                let y = (screenSize.height / 4);
                let initialDatas = element.getAttribute("data-init");
                if (initialDatas) {
                    initialDatas = JSON.parse(initialDatas);
                    if (initialDatas.x && initialDatas.y) {
                        ({ x, y } = initialDatas);
                    }
                }
                console.log(initialDatas, !!initialDatas, typeof initialDatas, x, y);
                element.setAttribute("data-x", x)
                element.setAttribute("data-y", y)
                const evt = {dx: 0, dy: 0, target: element};
                this.moveDraggable(evt);
                this.updateStoreWithPosition(evt);
            });
        
        }
        
    }
}
</script>